import { guardArray } from "../array";
import { moment } from "../date";
import type { AttendanceList, AttendanceSectionList, Nullable } from "../types";

export function createAttendanceSections(
	attendances: Nullable<AttendanceList>,
): AttendanceSectionList {
	const aggregated: AttendanceSectionList = [];

	for (const attendance of guardArray(attendances)) {
		const startDate = moment(attendance.startTime).db();
		const existingIndex = aggregated.findIndex((section) => section.title === startDate);
		if (aggregated[existingIndex]) {
			aggregated[existingIndex].data.push(attendance);
		} else {
			aggregated.push({
				title: startDate,
				data: [attendance],
			});
		}
	}

	return aggregated;
}
